/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The notification types that support the email channel. Client and backend both read the whole
 * class as the key list, so every member is a plain type key constant and nothing else.
 */
export class NotificationEmailTypeKeys {
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.InvoiceBatchFailed}
     */
    static readonly invoice_batch_failed: string = 'invoice_batch_failed';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.RequisitionStatusChanged}
     */
    static readonly requisition_status_changed: string = 'requisition_status_changed';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.RequisitionReceivedOperator}
     */
    static readonly requisition_received_operator: string = 'requisition_received_operator';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.AttachmentUploadFailed}
     */
    static readonly attachment_upload_failed: string = 'attachment_upload_failed';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.EmailNotDelivered}
     */
    static readonly email_not_delivered: string = 'email_not_delivered';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.InvoiceReceived}
     */
    static readonly invoice_received: string = 'invoice_received';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.ArchiveReady}
     */
    static readonly archive_ready: string = 'archive_ready';
}
